module.exports = __webpack_public_path__ + "static/img/member1_bg.c5954d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/member1_bg.png
// module id = L5Ug
// module chunks = 1